import i18n from "config/i18next";

i18n.addResources("es", "back", {
  goBack: "Volver",
});
